import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { DigitalDepositList } from './DigitalDepositList';
import { DigitalDepositAddress } from './DigitalDepositAddress';
import { DigitalDepositStackParamList, DigitalDepositStackRoutes } from './type';

const DigitalDepositStack = createNativeStackNavigator<DigitalDepositStackParamList>();

export const DigitalDepositNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.DigitalDeposit>> = ({
  route
}) => {
  const { account, refresh, record, onChangeView } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

return (
  <ModalContainerView dimensions={dimensions}>
    <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
      <DigitalDepositStack.Navigator
        initialRouteName={DigitalDepositStackRoutes.List}
        screenOptions={{
          presentation: layout.isMobile ? 'modal' : 'transparentModal',
          headerShown: false
        }}>
        <DigitalDepositStack.Screen
          name={DigitalDepositStackRoutes.List}
          component={DigitalDepositList}
          initialParams={{ onLayout, account, record, refresh }}
          options={{ headerShown: false }}
        />
        <DigitalDepositStack.Screen
          name={DigitalDepositStackRoutes.Address}
          component={DigitalDepositAddress}
          initialParams={{ onLayout, account, refresh, record, onChangeView }}
          options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
        />
      </DigitalDepositStack.Navigator>
    </View>
  </ModalContainerView>
);
};
